import { Component, OnInit, HostBinding, OnDestroy, Input, Type } from '@angular/core';
import * as type from '../../../buy/shared/action.event';
import { slideToRight, slideToTop } from '../../../shared/animations.collections';
import { Router, ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { FileService } from '../../../services/file.service';
import { CommonService } from '../../../services/common.service';
import { Subscription, Subject } from '../../../../../node_modules/rxjs';
import { ShoppingCart } from '../../../models/shopping-cart.model';
import { EventListenerService } from '../../../services/close-listenenr.service';
import { NgProgress } from '../../../../../node_modules/ngx-progressbar';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { WatchListItemNew } from '../../../models/watch-list.model';
import { WatchListService } from '../../../services/watch-list.service';
import { CurrentUserModel } from '../../../models/account-ledger.model';

// ngrx
import { Store, select } from '@ngrx/store';
import { LoadWatchList } from '../../../actions/watchlist.actions';
import { WatchListState, getWatchListStateLoaded, getWatchListStateProducts } from '../../../reducers/watchlist.reducer';
import { SelectShoppingCartNoRedirect, SelectShoppingCart, CreateShoppingCart } from '../../../actions/shoppingcart.actions';
import { AuthService } from '../../../services/auth.service';
import { take } from 'rxjs/operators';
import { NgProgressService } from '../../../services/ngProgress.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.css'],
  //animations: [slideToRight(), slideToTop()],
})
export class ShoppingCartComponent implements OnInit, OnDestroy {

  shoppingCarts: ShoppingCart[] = [];
  fliterdShoppingCarts: ShoppingCart[] = [];
  cartId: number;
  randomNameArray: string;
  url: string;
  watchListItems: WatchListItemNew[];
  editCart: string;
  editShoppingCart: ShoppingCart[];
  ngUnsubscribe: Subject<void> = new Subject<void>();
  closeResult: string;
  currentUserModel: CurrentUserModel;

  @Input('shoppingCartsInput') shoppingCartsInput: ShoppingCart[];

 // @HostBinding('@slideToTop') ani;
  title = 'CARTS';

  constructor(
    private closeService: EventListenerService,
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private fileService: FileService,
    private commonService: CommonService,
    private watchListService: WatchListService,
    private ngProgress: NgProgressService,
    private modalService: NgbModal,
    private store: Store<any>,
    private activeRouter: ActivatedRoute,
    private authService: AuthService,
  ) { }


  ngOnInit() {

    this.store.select(getWatchListStateLoaded).pipe(take(1))
      .subscribe(hasLoaded => {
        if (!hasLoaded) {
          this.store.dispatch(new LoadWatchList());
        }
        this.store.select(getWatchListStateProducts).subscribe(products => {
          this.watchListItems = products;
        }
        );
      });

    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
    });

    this.commonService.foundationService();

    this.shoppingCarts = this.fliterdShoppingCarts = this.commonService.orderBy(this.shoppingCartsInput, [
      (item: ShoppingCart) => item.isSelected,
      (item: ShoppingCart) => item.status
    ], ['desc', 'desc']);

    const selectedCart = this.shoppingCarts.find(cart => cart.isSelected);

    this.cartId = selectedCart.cartId;

    // this.watchListService.getWatchList().subscribe(ps => {
    //   this.watchListItems = ps;
    // },
    //   (error: any) => {
    //     console.error(error);
    //   });

    // if (this.shoppingCartsInput.length !== 0) {
    //   if (this.commonService.readCookie('CartId')) {
    //     this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    //     this.sortCartList();
    //     this.shoppingCartService.monitorCartId(toNumber(this.commonService.readCookie('CartId')));
    //   } else {
    //     this.commonService.createCookie('CartId', this.shoppingCartsInput[0].cartId.toString(), 7);
    //     this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    //     this.sortCartList();
    //     this.shoppingCartService.monitorCartId(toNumber(this.commonService.readCookie('CartId')));
    //   }
    // } else {
    //   this.addNewCart();
    // }

    // this.shoppingCartService.getShoppingCart().subscribe((sc: ShoppingCart[]) => {
    //   this.shoppingCarts = sc;
    //   if (sc.length !== 0) {
    //     if (this.commonService.readCookie('CartId')) {
    //       this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    //       this.sortCartList();
    //       this.shoppingCartService.monitorCartId(toNumber(this.commonService.readCookie('CartId')));
    //     } else {
    //       this.commonService.createCookie('CartId', sc[0].cartId.toString(), 7);
    //       this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    //       this.sortCartList();
    //       this.shoppingCartService.monitorCartId(toNumber(this.commonService.readCookie('CartId')));
    //     }
    //   } else {
    //     this.addNewCart();
    //   }
    // },
    //   (error: any) => {
    //     console.info(error);
    //   });

    // this.shoppingCartService.currentCartId.takeUntil(this.ngUnsubscribe).subscribe(cn => {
    //   this.cartId = cn;
    // },
    //   (error: any) => { console.error(error); });
  }

  accessWatchList(): void {
    this.router.navigateByUrl('/myCarts/watchlist');
  }

  open(content, event) {
    event.preventDefault();
    event.stopPropagation();
    this.modalService.open(content, { centered: true }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // deleteCart(cartId: number, cartName: string): void {

  //   this.ngProgress.start();

  //   this.shoppingCartService.deleteShoppingCart(cartId)
  //     .subscribe(success => {
  //       if (success) {
  //         this.shoppingCartService
  //           .getShoppingCart()
  //           .subscribe(sc => {
  //             this.shoppingCarts = sc;
  //             if (this.cartId == cartId) {
  //               this.shoppingCartService.monitorCartId(this.shoppingCarts[0].cartId);
  //               this.shoppingCartService.monitorCartIdChange(this.shoppingCarts[0].cartId);
  //               this.commonService.createCookie("CartId", this.shoppingCarts[0].cartId.toString(), 7);
  //             }
  //             this.shoppingCartService.monitorCartNameChange(cartId.toString() + cartName);
  //           },
  //             (error: any) => {
  //               this.ngProgress.done();
  //               console.info(error);
  //             });
  //       }
  //       this.ngProgress.done();
  //     },
  //       (error: any) => {
  //         this.ngProgress.done();
  //         console.info(error);
  //       });
  // }


  sortCartList(): void {
    this.shoppingCarts = this.commonService.orderBy(this.shoppingCarts, [
      (item: ShoppingCart) => item.isSelected,
      (item: ShoppingCart) => item.status
    ], ['desc', 'desc']);
  }

  selectCartNoRedirect(shoppingcart: ShoppingCart): void {

    if (shoppingcart.cartId !== this.cartId) {
      // select
      this.store.dispatch(new SelectShoppingCartNoRedirect(shoppingcart.cartId));
    }
    // this.shoppingCartService.monitorCartId(shoppingcart.cartId);
    // this.shoppingCartService.monitorCartIdChange(shoppingcart.cartId);
    // this.commonService.createCookie('CartId', shoppingcart.cartId.toString(), 7);
    // this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    // this.sortCartList();
  }

  selectCart(shoppingcart: ShoppingCart): void {
    if (shoppingcart.cartId !== this.cartId) {
      // select
      this.store.dispatch(new SelectShoppingCart(shoppingcart));
    } else {
      this.router.navigateByUrl('/myCarts/cart/' + shoppingcart.cartId + '/' + shoppingcart.cartName);
    }
    // this.shoppingCartService.monitorCartId(shoppingcart.cartId);
    // this.shoppingCartService.monitorCartIdChange(shoppingcart.cartId);
    // this.commonService.createCookie('CartId', shoppingcart.cartId.toString(), 7);
    // this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    // this.sortCartList();
    // this.router.navigateByUrl('/myCarts/cart/' + shoppingcart.cartId + '/' + shoppingcart.cartName);
  }

  searchShoppingCart(searchInput: string): void {

    this.fliterdShoppingCarts = this.shoppingCarts.filter(cn => cn.cartName.toLowerCase().includes(searchInput.toLowerCase()));
    // if (searchInput) {
    //   this
    //     .shoppingCartService
    //     .getShoppingCart()
    //     .subscribe(sc => {
    //       // this.shoppingCarts = sc.filter(cn => cn.cartName.indexOf(searchInput) != -1);
    //       this.shoppingCarts = sc.filter(cn => cn.cartName.toLowerCase().includes(searchInput.toLowerCase()));
    //       this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    //       this.sortCartList();
    //     },
    //       (error: any) => {
    //         // tslint:disable-next-line:no-console
    //         console.info(error);
    //       });
    // } else {
    //   this
    //     .shoppingCartService
    //     .getShoppingCart()
    //     .subscribe(sc => {
    //       this.shoppingCarts = sc;
    //       this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
    //       this.sortCartList();
    //     },
    //       (error: any) => {
    //         // tslint:disable-next-line:no-console
    //         console.info(error);
    //       });
    // }
  }

  editCartName(cartName: string): void {
    this.editCart = cartName;
  }

  confirmCartNameValue(editCart: string, shoppingcart: ShoppingCart): void {
    this.ngProgress.start();
    if (shoppingcart.cartName !== editCart) {
      this.editShoppingCart = this.shoppingCarts.filter(cn => cn.cartName === editCart);
      if (this.editShoppingCart.length === 0) {
        this.editCart = '';
        this.shoppingCartService.monitorCartNameChange(editCart);
        this.shoppingCartService.updateCartName(editCart, shoppingcart.cartId)
          .subscribe(success => {
            if (success.status) {
              this.shoppingCartService.getShoppingCart()
                .subscribe(sc => {
                  this.shoppingCarts = sc;
                  this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
                  this.sortCartList();
                  this.ngProgress.done();
                },
                  (error: any) => {
                    this.ngProgress.done();
                    // tslint:disable-next-line:no-console
                    console.info(error);
                  });
            }
          },
            (error: any) => {
              this.ngProgress.done();
              // tslint:disable-next-line:no-console
              console.info(error);
            });
      } else {
        // this.commonService.showError(".edit" + shoppingcart.cartId.toString(), "Cart Names Can not be the Same", "left");
        this.commonService.implementToast('Cart Names Can not be the Same', 'Error');
      }
    } else {
      this.editCart = '';
    }

  }

  editCartDetail(cartId: number, cartName: string): void {
    this.shoppingCartService.monitorCartId(cartId);
    this.shoppingCartService.monitorCartIdChange(cartId);
    this.commonService.createCookie('CartId', cartId.toString(), 7);
    this.router.navigateByUrl('/myCarts/cart/' + cartId + '/' + cartName);
  }

  addNewCart(): void {
    this.ngProgress.start();
    this.randomNameArray = this.shoppingCartService.RandomCartName(this.shoppingCarts);
    this.shoppingCartService.createShoppingCart(this.randomNameArray).subscribe((res: number) => {
      this.shoppingCartService.monitorCartId(res);
      this.shoppingCartService.monitorCartIdChange(res);
      this.commonService.createCookie('CartId', res.toString(), 7);
      // this.commonService.showSuccess(".btnAddBlade", "Successfully Add Shopping Cart", "left");
      this.commonService.implementToast('Successfully Add Shopping Cart', 'Success');
      this
        .shoppingCartService
        .getShoppingCart()
        .subscribe(sc => {
          this.shoppingCarts = sc;
          this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
          this.sortCartList();
          this.ngProgress.done();
        },
          // tslint:disable-next-line:no-console
          (error: any) => { console.info(error); });

    },
      (error: any) => {
        // this.commonService.showError(".btnAdd", error.responseMessage, "right");
        this.commonService.implementToast(error.responseMessage, 'Error');
        this.ngProgress.done();
      });
  }

  addNewCartWithName(cartName: string): void {
    if (cartName === '') {
      this.store.dispatch(new CreateShoppingCart());
    } else {
      this.store.dispatch(new CreateShoppingCart(cartName));
    }

    // this.ngProgress.start();
    // this.randomNameArray = this.shoppingCartService.RandomCartName(this.shoppingCarts);
    // this.shoppingCartService.createShoppingCart(this.randomNameArray).subscribe((res: number) => {
    //   this.shoppingCartService.monitorCartId(res);
    //   this.shoppingCartService.monitorCartIdChange(res);
    //   this.commonService.createCookie('CartId', res.toString(), 7);
    //   this.shoppingCartService.updateCartName(cartName, res)
    //     .subscribe(success => {
    //       if (success.status) {
    //         this.shoppingCartService.monitorCartNameChange(cartName);
    //         this.shoppingCartService.getShoppingCart()
    //           .subscribe(sc => {
    //             this.shoppingCarts = sc;
    //             this.shoppingCartService.setSelected(this.shoppingCarts, res.toString());
    //             this.sortCartList();
    //             this.shoppingCartService.setCacheShoppingCart(this.shoppingCarts);
    //             this.ngProgress.done();
    //             // this.router.navigateByUrl(`/myCarts/cart/${this.commonService.readCookie('CartId')}/${cartName}`);
    //           },
    //             (error: any) => {
    //               this.ngProgress.done();
    //               console.error(error);
    //             });
    //         // this.commonService.showSuccess(".add-cart-btn", success.responseMessage, "right");
    //         this.commonService.implementToast(success.responseMessage, 'Success');
    //         // setTimeout(() => {
    //         //   $('#changeCartNameContainer').foundation('close');
    //         // }, 1000);
    //       } else {
    //         // this.commonService.showError(".add-cart-btn", success.responseMessage, "right");
    //         this.commonService.implementToast(success.responseMessage, 'Error');
    //       }
    //     },
    //       (error: any) => {
    //         this.ngProgress.done();
    //         console.error(error);
    //       });
    // });
  }

  setActiveCart(cartId: string) {
    this.shoppingCartService.SetActiveCart(cartId).subscribe(res => {

    });
  }

  downloadExcel(): void {

    this.ngProgress.start();

    this.fileService.exportAllCartsToExcel().subscribe(data => {

      const loginId = this.commonService.readCookie('LoginId');
      const fileName = `"DD_ShoppingCart_${loginId}.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);
      this.ngProgress.done();

    },
      (error: any) => {
        // tslint:disable-next-line:no-console
        console.info(error);
        this.ngProgress.done();
      });

  }

  closeSetting() {
    this.closeService.closeEvent(type.SHOPPINGCART);
  }

  onClickShopCart(shopCartEvent) {
    shopCartEvent.stopPropagation();
    this.shoppingCartService.monitorEvent(shopCartEvent);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
